"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const caseStudies = [{
  number: "01",
  category: "PINTURA & REVESTIMENTO",
  title: "Aplicações de Secagem",
  body: "Uma secagem eficiente após o enxaguamento, pré-tratamento ou revestimento é essencial para prevenir defeitos e manter a produção em movimento. Os bicos de ar WindJet® e as facas de ar proporcionam ar de elevada velocidade para remover rapidamente água, fluido de refrigeração e detritos. Ideais para correias transportadoras, células robóticas e túneis de secagem, com consumo mínimo de ar comprimido. Os amplificadores de ar WindJet® são ideais para secagem pontual, sopro e aplicações de exaustão.\n\nFluxos de ar de elevado impacto para secagem rápida e uniforme\nOpções para sistemas de ar comprimido ou acionados por soprador\nReduz defeitos relacionados com a humidade e minimiza os custos energéticos\nProporciona um fluxo de ar direcionado de elevado volume e elevada velocidade para secagem e sopro rápidos",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.11.44.png?v=46wt695wdt3",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.11.44.png?v=1g6yu0dw13p-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.11.44.png?v=qz29w6s71in-wvc-sizes",
  alt: "Sistema de pintura e revestimento de alta precisão para a indústria automóvel",
  href: "/AutomotiveManufacturingSuccessCasePage"
}];
export default function Casestudyshowcase() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".vlt-header", {
        opacity: 0,
        y: 24
      });
      gsap.set(".vlt-card", {
        opacity: 0,
        y: 36
      });
      gsap.to(".vlt-header", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".vlt-header",
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".vlt-card", {
        opacity: 1,
        y: 0,
        duration: 0.85,
        stagger: 0.15,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".vlt-grid",
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".vlt-header", ".vlt-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31429" id="casestudyshowcase" className="bg-background text-foreground py-24 md:py-36 relative overflow-hidden">
      <div ref={container} className="mx-auto max-w-[1360px] px-5 md:px-8 lg:px-12">
        {}
        

        {}
        <div className="vlt-grid grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch">
          {caseStudies.map((item, i) => <div key={item.number} data-index={i} className="vlt-card bg-card text-card-foreground border border-border/70 rounded-3xl p-6 lg:p-8 flex flex-col justify-between shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 group">
              <div>
                {}
                <div className="relative aspect-[3/2] w-full overflow-hidden rounded-xl mb-6 bg-muted border border-border/40">
                  <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>

                {}
                <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">
                  {item.number} — {item.category}
                </div>

                {}
                <h3 className="text-xl lg:text-2xl font-bold text-foreground mb-3 leading-snug">
                  {item.title}
                </h3>

                {}
                <p className="text-sm lg:text-base text-muted-foreground leading-relaxed mb-6">
                  {item.body}
                </p>
              </div>

              {}
              <div className="pt-2 border-t border-border/40 mt-2">
                <Link to={item.href} className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-colors duration-200 group/link">
                  <span>Saber mais</span>
                  <span className="inline-flex items-center justify-center rounded-lg border border-border/80 w-7 h-7 bg-background group-hover/link:border-primary group-hover/link:bg-primary group-hover/link:text-primary-foreground transition-all duration-200">
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}